import { useEffect, useState } from "react";
import {
  TkStaffChangeProps,
  TkStaffChangesTableProps,
} from "../../../type/componentsType/ITkStaffChangesTableProps";
import TkTable from "../../../components/atoms/TkTable";
import TkRaio from "../../../components/atoms/TkRadio";
import { RetireeStatus, TransferStatus } from "../../../assets/data/Constants";

/**
 * スタッフ変更を表示するためのテーブル部品をレンダリングします。
 * @param {staffs} props スタッフ変更情報。
 * @param {onChange} props スタッフ変更情報が変更された際のコールバック関数。
 * @returns TkStaffChangesTable スタッフ変更テーブル部品
 */
export const TkStaffChangesTable: React.FC<TkStaffChangesTableProps> = (
  props
) => {
  const { staffs = [], onChange, isTkStaffChangesHeadDisabled } = props;
  const [staffList, setStaffList] = useState<TkStaffChangeProps[]>(staffs);
  const [bodyList, setBodyList] = useState<{ children: any }[][]>([]);
  const headList = [
    { headTitle: "譲渡先法人へ異動", className: "tkStaffChangesHead" },
    { headTitle: "退職", className: "tkStaffChangesHead" },
    { headTitle: "氏名", className: "tkStaffChangesHead" },
  ];

  const handleRadioChange = (
    index: number,
    type: "transfer" | "retirement"
  ) => {
    const newStaffs = staffs.map((staff, i) => {
      if (i === index && type === "transfer") {
        if (staff.transfer === TransferStatus["未選択"]) {
          staff.retirement = RetireeStatus["未選択"];
        }
        staff.transfer =
          staff.transfer === TransferStatus["選択"]
            ? TransferStatus["未選択"]
            : TransferStatus["選択"];
      } else if (i === index && type === "retirement") {
        if (staff.retirement === RetireeStatus["未選択"]) {
          staff.transfer = TransferStatus["未選択"];
        }
        staff.retirement =
          staff.retirement === RetireeStatus["選択"]
            ? RetireeStatus["未選択"]
            : RetireeStatus["選択"];
      }
      return staff;
    });
    setStaffList([...newStaffs]);
    onChange && onChange(newStaffs);
  };

  useEffect(() => {
    const list = staffs.map((staff) => {
      return [
        {
          children: (
            <TkRaio
              checked={staff.transfer === TransferStatus["選択"]}
              name={`${staff.index}`}
              onClick={() => handleRadioChange(staff.index, "transfer")}
              value="transfer"
              disabled={isTkStaffChangesHeadDisabled}
            />
          ),
          align: "center",
          width: "30%",
          className: "tkStaffChangesBody",
        },
        {
          children: (
            <TkRaio
              checked={staff.retirement === RetireeStatus["選択"]}
              name={`${staff.index}`}
              onClick={() => handleRadioChange(staff.index, "retirement")}
              value="retirement"
            />
          ),
          align: "center",
          width: "30%",
          className: "tkStaffChangesBody",
        },
        {
          children: staff.num + ":" + staff.name,
          width: "40%",
          className: "tkStaffChangesBody",
          backgroundColor:
            staff.transfer === TransferStatus["未選択"] &&
            staff.retirement === RetireeStatus["未選択"]
              ? "#ffff00"
              : "",
        },
      ];
    });
    setBodyList([...list]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffList, staffs]);

  return <TkTable headList={headList} bodyList={bodyList} />;
};

export default TkStaffChangesTable;
